export default __webpack_public_path__ + "c5fee4d9e3832e5d28aee6dcf6835d82.png";